module.exports = __webpack_public_path__ + "static/media/Branding-SF-Medium.8adb351a.otf";